export class CriteriaFromStringBuilderViewModel
{
    isOpen = false;

    parentId: number | null = null;
    parentName = '';

    show(parentId: number, parentName: string)
    {
        this.parentId = parentId;
        this.parentName = parentName;
        this.isOpen = true;
    }

    close()
    {
        this.isOpen = false;
        this.parentId = null;
        this.parentName = '';
    }
}
